import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getUsers,
  createUser,
  updateUser,
  deleteUser,
  getCountries,
  getAllStates,
  getLanguages,
} from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import {
  showSuccessToastMessage,
  showErrorToastMessage,
  emptyCheck,
  validateEmail,
  validatePassword,
  isSuperAdmin,
  validatePasswordConsecutiveCharacter,
} from "../../../../utilities";
import Grid from "../Common/Grid";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
import AdminBreadcrumb from "../Common/Breadcrumb";
import RequiredField from "../Common/RequiredField";

class AdminUsers extends Component {
  state = {
    authorized: false,
    masterusers: [],
    users: [],
    selectedUser: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    countries: [],
    languages: [],
    states: [],
    statesByCountry: [],
    errorMessage: "",
  };
  componentDidMount() {
    if (isSuperAdmin()) {
      this.setState({ authorized: true });
      this.getUsersFromService();
    }
    // this.getCountriesForR();
    // this.getStatesForR();
    // this.getLanguagesForR();
  }

  getCountriesForR() {
    this.showSpinner(true);
    let arrCountries = [];
    getCountries().then((response) => {
      this.showSpinner(false);
      for (let country of response.data) {
        arrCountries.push(
          <option key={country.Id} value={country.Id}>
            {country.Name}
          </option>
        );
      }
      this.setState({ countries: arrCountries });
    });
  }

  getStatesForR() {
    this.showSpinner(true);
    let arrStates = [];
    getAllStates().then((response) => {
      this.showSpinner(false);
      for (let state of response.data) {
        arrStates.push(state);
      }
      this.setState({ states: arrStates });
    });
  }

  getLanguagesForR() {
    let arrLanguages = [];
    this.showSpinner(true);
    getLanguages().then((response) => {
      this.showSpinner(false);
      for (let language of response.data) {
        arrLanguages.push(
          <option key={language.Id} value={language.Id}>
            {language.Name}
          </option>
        );
      }
      this.setState({ languages: arrLanguages });
    });
  }
  countryChanged(event) {
    this.countryChangedHandle(event.target.value);
  }

  countryChangedHandle(id) {
    let arrStates = [];
    let states = this.state.states.filter((d) => d.CountryId === parseInt(id, 10));
    for (let state of states) {
      arrStates.push(
        <option key={state.Id} value={state.Id}>
          {state.Name}
        </option>
      );
    }
    this.setState({ statesByCountry: arrStates });
  }

  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow,
    });
  }
  getUsersFromService() {
    this.showSpinner(true);
    getUsers()
      .then((response) => {
        this.setState({ users: response.data, masterusers: response.data });
        this.showSpinner(false);
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error);
        this.showErrorMessage(error);
      });
  }

  editUser(user) {
    this.countryChangedHandle(user.CountryId);
    const objUser = {
      ...user,
      IsUser: user.Roles.toLowerCase().indexOf("user") >= 0,
      IsAdmin: user.Roles.toLowerCase().indexOf("admin") >= 0,
    };
    this.setState({
      action: "edit",
      selectedUser: objUser,
      showModal: true,
    });
  }

  deleteUser(user) {
    this.setState({
      action: "delete",
      selectedUser: user,
      showDeleteModal: true,
    });
  }

  addUser() {
    this.setState({
      action: "add",
      selectedUser: { StateId: -1, CountryId: -1, LanguageId: -1 },
      showModal: true,
    });
  }
  onHideModal() {
    this.setState({
      showModal: false,
      errorMessage: "",
    });
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false,
    });
  }
  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "User");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }
  validate(data) {
    // console.log(data);
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    if (emptyCheck(data.Email)) {
      this.setState({ errorMessage: "Email cannot be blank" });
      return false;
    }
    // if (data.LanguageId === "-1") {
    //   this.setState({ errorMessage: "Please select language" });
    //   return false;
    // }
    // if (data.CountryId === "-1") {
    //   this.setState({ errorMessage: "Please select country" });
    //   return false;
    // }
    // if (data.StateId === "-1") {
    //   this.setState({ errorMessage: "Please select state" });
    //   return false;
    // }
    // if (emptyCheck(data.Roles)) {
    //   this.setState({ errorMessage: "Please select user role" });
    //   return false;
    // }
    if (!validateEmail(data.Email)) {
      this.setState({
        error: true,
        errorMessage: "Please enter a valid email address",
      });
      return false;
    }
    if (data.IsPasswordChanged || this.state.action === "add") {
      if (data.Password.trim().length < 12) {
        this.setState({
          error: true,
          errorMessage: "Password must be at least twelve (12) characters long",
        });
        return false;
      }
      if (!validatePassword(data.Password)) {
        this.setState({
          error: true,
          errorMessage:
            "Password must contain at least three of these: number, lowercase, uppercase letter, special character",
        });
        return false;
      }
      if (validatePasswordConsecutiveCharacter(data.Password, data.Name)) {
        this.setState({
          error: true,
          errorMessage: "The password must not contain the full name that exceed two consecutive characters",
        });
        return false;
      }
      if (validatePasswordConsecutiveCharacter(data.Password, data.Email.split("@")[0])) {
        this.setState({
          error: true,
          errorMessage: "The password must not contain the email that exceed two consecutive characters",
        });
        return false;
      }
    }
    return true;
  }
  saveUser() {
    // let roles;
    // roles = this.refs["chkUser"].checked ? "User" : "";
    // roles += this.refs["chkAdmin"].checked ? ",Admin" : "";
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedUser.Id : 0,
      Name: this.refs["txtName"].value,
      Email: this.refs["txtEmail"].value,
      Password: this.refs["txtPassword"].value,
      EmailConfirmed: true, //this.refs["chkEmailConfirmed"].checked,
      LanguageId: 1, // this.refs["selLanguage"].value,
      CountryId: 1, //this.refs["selCountry"].value,
      StateId: 1, // this.refs["selState"].value,
      Roles: this.refs["selRole"].value, //"User", // roles,
      IsPasswordChanged: this.state.selectedUser.Password === this.refs["txtPassword"].value ? false : true,
      IsApproved: true,
      IsFrontend: false,
    };
    if (this.validate(data)) {
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          createUser(data)
            .then((response) => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getUsersFromService();
            })
            .catch((error) => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        case "edit":
          this.showSpinner(true);
          updateUser(data)
            .then((response) => {
              this.showSpinner(false);
              // console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getUsersFromService();
            })
            .catch((error) => {
              this.showSpinner(false);
              // console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        default:
          break;
      }
    }
  }
  confirmDeleteUser() {
    this.showSpinner(true);
    deleteUser(this.state.selectedUser.Id)
      .then((response) => {
        this.showSpinner(false);
        // console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedUser.Name);
        this.getUsersFromService();
      })
      .catch((error) => {
        this.showSpinner(false);
        // console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleUserChange = (event) => {
    let selectedUser = this.state.selectedUser;
    selectedUser.Name = event.target.value;
    this.setState({ selectedUser: selectedUser });
  };

  manageJobRoles(user) {
    // this.props.history.push(`/admin/jobroles/` + user.Id);
  }

  handlePasswordChange = (e) => {
    const password = e.target.value;
    let errorMessage = "";
    if (password.trim().length === 0) {
      this.setState({
        error: false,
        errorMessage: null,
      });
      return false;
    }
    if (password.trim().length < 12) {
      errorMessage += "Password must be at least twelve (12) characters long <br/>";
    }
    if (!validatePassword(password)) {
      errorMessage +=
        "Password must contain at least three of these: number, lowercase, uppercase letter, special character <br />";
    }
    if (validatePasswordConsecutiveCharacter(password, this.refs["txtName"].value)) {
      errorMessage += "The password must not contain the full name that exceed two consecutive characters <br />";
    }
    if (validatePasswordConsecutiveCharacter(password, this.refs["txtEmail"].value)) {
      errorMessage += "The password must not contain the email that exceed two consecutive characters <br />";
    }
    if (errorMessage.length > 0) {
      this.setState({
        error: true,
        errorMessage: errorMessage,
      });
    } else {
      this.setState({
        error: false,
        errorMessage: null,
      });
    }
  };

  handleSearchTermChange = (event) => {
    let filteredUsers = this.state.masterusers.filter((d) => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        users: filteredUsers,
        searchTerm: event.target.value,
      });
    else
      this.setState({
        users: this.state.masterusers,
        searchTerm: event.target.value,
      });
  };

  render() {
    const { authorized } = this.state;

    if (!authorized) {
      return <h3 className="page-header">You are not authorized to view this page!</h3>;
    }
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">User Management</h1>
        <AdminBreadcrumb data={[{ name: "Home", link: "/admin/modules/" }, { name: "Users" }]} />
        <button className="btn btn-default add-btn" onClick={() => this.addUser()}>
          Add User
        </button>
        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} />
        <Grid
          headers={["#", "Name", "Email", "Role"]}
          values={this.state.users}
          indexName="Id"
          properties={["Id", "Name", "Email", "Roles", "Action"]}
          edit={(value) => this.editUser(value)}
          delete={(value) => this.deleteUser(value)}
          // extraActions={[value => this.manageJobRoles(value)]}
          // extraActionNames={["Edit Role"]}
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveUser()}
          form={this.addeditform}
          type="User"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />
              Name:
            </label>
            <input
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtName"
              defaultValue={this.state.selectedUser.Name}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Email:
            </label>
            <input
              maxLength="100"
              type="text"
              className="form-control"
              ref="txtEmail"
              disabled={this.state.action === "edit" ? true : false}
              defaultValue={this.state.selectedUser.Email}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Password:
            </label>
            <input
              maxLength="100"
              type="password"
              className="form-control"
              ref="txtPassword"
              defaultValue={this.state.selectedUser.Password}
              onChange={this.handlePasswordChange}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Role:
            </label>
            <select
              ref="selRole"
              className="form-control"
              defaultValue={this.state.selectedUser.Roles}
              disabled={this.state.action === "edit" ? true : false}
            >
              <option value="User">User</option>
              <option value="Admin">Admin</option>
            </select>
          </div>
          <div>
            <label>
              <strong>Password Policy:</strong>
            </label>
            <ul>
              <li>Password must be at least twelve (12) characters long</li>
              <li>
                Password must contain at least three of these: number, lowercase, uppercase letter, special character
              </li>
              <li>The password must not contain the full name that exceed two consecutive characters</li>
              <li>The password must not contain the email that exceed two consecutive characters</li>
            </ul>
          </div>

          {/* <div className="form-group">
            <label>Is EmailConfirmed?:</label>
            <input
              type="checkbox"
              className="chkBoxCustom"
              ref="chkEmailConfirmed"
              defaultChecked={this.state.selectedUser.EmailConfirmed}
            />
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Language:
            </label>
            <select
              ref="selLanguage"
              className="form-control"
              defaultValue={this.state.selectedUser.LanguageId}
            >
              <option value={-1}>Select Language</option>
              {this.state.languages}
            </select>
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Country:
            </label>
            <select
              ref="selCountry"
              className="form-control"
              defaultValue={this.state.selectedUser.CountryId}
              onChange={event => this.countryChanged(event)}
            >
              <option value={-1}>Select Country</option>
              {this.state.countries}
            </select>
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              State:
            </label>
            <select
              ref="selState"
              className="form-control"
              defaultValue={this.state.selectedUser.StateId}
            >
              <option value={-1}>Select State</option>
              {this.state.statesByCountry}
            </select>
          </div>
          <div className="form-group">
            <label>
              <RequiredField />
              Role:
            </label>
            <input
              type="checkbox"
              className="chkBoxCustom"
              ref="chkUser"
              defaultChecked={this.state.selectedUser.IsUser}
            />
            <label>User</label>
            <input
              type="checkbox"
              className="chkBoxCustom"
              ref="chkAdmin"
              defaultChecked={this.state.selectedUser.IsAdmin}
            />
            <label>Admin</label>
          </div> */}
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedUser.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          confirm={() => this.confirmDeleteUser()}
          name={this.state.selectedUser.Name}
          type="User"
        />
      </Aux>
    );
  }
}

export default AdminUsers;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/Users/Users.js